var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-info-card',{attrs:{"title":"Post Categories"}},[_c('ul',{staticClass:"pl"},_vm._l((_vm.categories),function(category){return _c('li',{key:category,staticClass:"mb-3",domProps:{"textContent":_vm._s(category)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }